export const FALLBACK_FONT_STACK = `'-apple-system', BlinkMacSystemFont, Roboto, 'SF Arabic', 'Segoe UI', 'Noto Sans', 'Helvetica Neue', Helvetica, sans-serif`;
